<template>
    <Page :title="$t('payments.edit.title')">
        <div>{{ $t('payments.edit.dummy_text') }}</div>
    </Page>
</template>

<script>
import Page from '@/components/ui/Page';
export default {
    components: { Page },
};
</script>
